import type { EventObjectProperties } from './track-event.types';

export const removeNullValuesFromEvent = (event: EventObjectProperties) =>
  Object.fromEntries(
    Object.entries(event).filter(([, value]) => value !== null),
  ) as Record<string, string | number | boolean>;

const trackEvent = (object?: EventObjectProperties) => {
  if (!window || !object) return false;
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push(removeNullValuesFromEvent(object));
  return true;
};

let lastSequenceKey = '';
let bufferedEvents: EventObjectProperties[] = [];
let sequenceIds: string[] = [];
let flushTimeout: NodeJS.Timeout | null = null;

const sentKeys = new Set<string>();

const generateSequenceKey = (ids: string[]) => ids.join('|');

const flush = () => {
  const currentKey = generateSequenceKey(sequenceIds);
  if (currentKey !== lastSequenceKey) {
    for (const event of bufferedEvents) {
      const key = `${event.retailerSlug}`;
      if (!sentKeys.has(key)) {
        trackEvent(event);
        sentKeys.add(key);
      }
    }
    lastSequenceKey = currentKey;
  }
  bufferedEvents = [];
  sequenceIds = [];
};

export const trackEventUnique = (event: EventObjectProperties) => {
  const key = `${event.retailerSlug}`;
  if (!event.retailerSlug) return false;
  sequenceIds.push(key);
  bufferedEvents.push(event);

  if (flushTimeout) clearTimeout(flushTimeout);
  flushTimeout = setTimeout(flush, 100);

  return true;
};

export default trackEvent;
